// extracted by mini-css-extract-plugin
export default {"modalContainer":"l1-z","modalIndicator":"m1-z","prevBtn":"n1-z","nextBtn":"o1-z","body":"p1-z","footer":"q1-z"};